module.exports = __webpack_public_path__ + "static/media/resultsGraphicFailed2.fc656618.JPG";